module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6A2ER66TjO8ugYKaXbvMZs-a1a00e1493eb846927c9e4a8d009de94.jpg";